import { FETCH_ZONE_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const zoneListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ZONE_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default zoneListReducer;
